export default [
  {
    path: '/admin-treasury',
    name: 'AdminTreasury',
    component: () => import('@/views/admin/treasury.vue'),
    meta: {
      auth: true,
      title: 'XZEC 合约转入地址',
      keepAlive: false,
      headerTheme: 'dark'
    }
  }
]
